import { render, staticRenderFns } from "./MapaSugal.vue?vue&type=template&id=6d82193b&scoped=true&"
import script from "./MapaSugal.vue?vue&type=script&lang=ts&"
export * from "./MapaSugal.vue?vue&type=script&lang=ts&"
import style0 from "./MapaSugal.vue?vue&type=style&index=0&id=6d82193b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d82193b",
  null
  
)

export default component.exports